import type { SkeletonProps } from './Skeleton.types';
import clsx from 'clsx';

export const Skeleton = (props: SkeletonProps) => {
  const { className = 'w-full h-4 rounded-md', style = undefined } = props;
  return (
    <div
      data-testid="skeleton"
      className={clsx('animate-pulse bg-neutral-light', className)}
      style={style}
      aria-hidden
    />
  );
};

Skeleton.displayName = 'Skeleton';
